<template>
  <div class="table-wrapper" :class="{'is-edit':editMode}">
    <div class="table-header">
      {{ title }}
    </div>
    <div class="table-body" style="overflow-x: auto">
      <table class="table">
        <thead>
          <tr>
            <th v-if="editMode"> &nbsp; </th>

            <th v-if="editMode" class="text-center"> Projet </th>
            <template v-else>
              <th style="white-space: nowrap; width: 75px"># Projet</th>
              <th>Nom du projet</th>
            </template>

            <th v-if="editMode" class="text-center"> Phase </th>
            <template v-else>
              <th class="text-center" style="white-space: nowrap; width: 50px">Phase</th>
              <th style="width: 10%">Nom phase</th>
            </template>

            <th v-if="editMode" class="text-center"> {{activityNameLabel}} </th>
            <template v-else>
              <th class="text-center" style="white-space: nowrap; width: 50px">{{activityNumberLabel}}</th>
              <th style="width: 10%">{{activityNameLabel}}</th>
            </template>

            <th v-for="(day, index) in days" :key="index" class="text-center" style="width: 50px">
              {{day.dateOfMonth}} <br> {{day.dayShort}}
            </th>
            <th class="text-center" style="width: 50px">Total</th>
            <th>Commentaire</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(row, index) in rows">
            <tr :key="index" class="timesheet-entry-row" :class="row.timesheet_entry_is_adjustment == '1' ? 'timesheet-entry-adjustment' : ''">

              <td v-if="editMode" style="width: 1%;">
                <button v-if="!row.partial && row.timesheet_entry_is_adjustment != '1'" class="btn btn-sm btn-danger" style="margin-right: 0" @click="deleteRowAsk(row)"><i class="fa fa-trash"></i></button>
              </td>

              <td class="text-center" v-if="editMode">
                <select2 
                  ref="rowProjectSelect2" 
                  class="text-left timesheet-entry-project" 
                  placeholder="Sélectionner" 
                  :endpoint="projectSelect2Endpoint" 
                  @selected="projectSelected(row, $event)" 
                  @clear="projectSelected(row, null)"
                  :value="row.project_id == null ? undefined : {id: row.project_id, text: row.project_number + ' - ' + row.project_name}"
                  :renderMethod="projectRenderMethod"
                  :disabled="row.timesheet_entry_is_adjustment == '1'"
                />
              </td>
              <template v-else>
                <td class="text-center">{{row.project_number}}</td>
                <td>{{row.project_name}}</td>
              </template>

              <td class="text-center" style="width: 200px" v-if="editMode">
                <select2 
                  ref="rowPhaseSelect2" 
                  class="text-left timesheet-entry-phase" 
                  placeholder="Sélectionner" 
                  :endpoint="phaseSelect2Endpoint" 
                  @selected="phaseSelected(row, $event)" 
                  @clear="phaseSelected(row, null)"
                  :attributes="{project_id: row.project_id}"
                  :value="row.project_phase_id == null ? undefined : {id: row.project_phase_id, text: row.project_phase_number + ' - ' + row.project_phase_description}"
                  :disabled="row.timesheet_entry_is_adjustment == '1'"
                />
              </td>
              <template v-else>
                <td class="text-center">{{row.project_phase_number}}</td>
                <td>{{row.project_phase_description}}</td>
              </template>

              <td class="text-center" style="width: 200px" v-if="editMode && displayActivityInputs">
                <select2 
                  ref="rowActivitySelect2" 
                  class="text-left timesheet-entry-activity" 
                  placeholder="Sélectionner" 
                  :endpoint="activitySelect2Endpoint" 
                  @selected="activitySelected(row, $event)" 
                  @clear="activitySelected(row, null)"
                  :value="row.activity_id == null ? undefined : {id: row.activity_id, text: row.activity_number + ' - ' + row.activity_name}"
                  :disabled="row.timesheet_entry_is_adjustment == '1'"
                />
              </td>
              <template v-else-if="displayActivityInputs">
                <td class="text-center">{{row.activity_number}}</td>
                <td>{{row.activity_name}}</td>
              </template>
              <td :colspan="editMode ? 1 : 2" v-else>&nbsp;</td>

              <td v-for="(day, index2) in days" :key="`${index}_${index2}`" style="white-space: nowrap; width: 30px;">
                <div v-if="editMode">
                  <input 
                    type="text" 
                    :value="formatDigit(dayValue(row.days[day.date]), valueDecimals)" 
                    @change="rowUpdated(row, {day: {date: day.date, value: $event.target.value}})" 
                    class="input-text-fancy input-sm input-right timesheet-entry-value" 
                    @click="$event.target.select()" 
                    :disabled="row.timesheet_entry_is_adjustment == '1'"
                  />
                </div>
                <div v-else style="padding: 0 3px;" class="text-center">
                  <span v-if="dayValue(row.days[day.date]) != ''">
                    {{ formatDigit(dayValue(row.days[day.date]), valueDecimals) }}
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </div>
              </td>
              <td rowspan="2" class="text-right" style="white-space: nowrap; width: 1%;">{{ formatDigit(rowTotal(row), valueDecimals) }}</td>
              <td rowspan="2" style="width: 25%">
                <div v-if="editMode">
                  <input 
                    type="text" 
                    :value="row.timesheet_entry_comment" 
                    @change="rowUpdated(row, {'timesheet_entry_comment': $event.target.value})" 
                    class="form-control"
                    :disabled="row.timesheet_entry_is_adjustment == '1'"
                  />
                </div>
                <div v-else>
                  {{row.timesheet_entry_comment}}
                </div>
              </td>
            </tr>
            <tr class="timesheet-entry-row-error">
              <td></td>
              <td class="timesheet-entry-project">
                <div class="custom-error" style="display: none;">Champs requis</div>
              </td>
              <td class="timesheet-entry-phase">
                <div class="custom-error" style="display: none;">Champs requis</div>
              </td>
              <td class="timesheet-entry-activity">
                <div class="custom-error" style="display: none;">Champs requis</div>
              </td>
              <td :colspan="days.length" class="timesheet-entry-value">
                <div class="custom-error" style="display: none;">Veuillez saisir au moins un temps</div>
              </td>
            </tr>
          </template>
          <tr>
            <td :colspan="editMode ? 3 : 5"></td>
            <td class="bold text-center">Total</td>
            <td v-for="(day, index) in days" :key="index" class="text-right" style="white-space: nowrap; width: 30px;">
              <span style="padding: 0 3px">{{formatDigit(dayTotal(day), valueDecimals)}}</span>
            </td>
            <td class="text-right bold" style="white-space: nowrap; width: 1%;">{{ formatDigit(grandTotal, valueDecimals) }}</td>
            <td style="width: 25%">{{commentText}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import Select2 from '../Select2.vue';

  export default {
    name: "timesheet-section",
    components: { Select2, },
    props: {
      title: {
        type: String,
        default: "Heures projets"
      },
      commentText: {
        type: String,
        default: ""
      },
      activityNumberLabel: {
        type: String,
        default: "# Act"
      },
      activityNameLabel: {
        type: String,
        default: "Activité"
      },
      rows: {
        type: Array,
        required: true
      },
      start: {
        type: String,
        required: true
      },
      end: {
        type: String,
        required: true
      },
      editMode: {
        type: Boolean,
        required: true
      },
      rowType: {
        type: String,
        required: true
      },
      valueDecimals: {
        type: Number,
        default: 0
      },
      displayActivityInputs: {
        type: Boolean,
        default: true
      },
      activityType: {
        type: String,
        default: ''
      }
    },
    computed: {
      startDate() {
        return moment(this.start);
      },
      endDate() {
        return moment(this.end);
      },
      projectSelect2Endpoint() {
        return `${window.baseUrl}timesheet/select2/timesheet_project_id`;
      },
      phaseSelect2Endpoint() {
        return `${window.baseUrl}timesheet/select2/timesheet_project_phase_id`;
      },
      activitySelect2Endpoint() {
        switch(this.activityType){
          case "activity":
            return `${window.baseUrl}timesheet/select2/timesheet_activity_id`;
          case "expense":
            return `${window.baseUrl}timesheet/select2/timesheet_expense_type_id`;
        }
      },
      dayTotal() {
        return (day) => {
          this.updateCounter;
          let total = 0;

          for (const row of this.rows) {
            let val = row.days[day.date]
            if(val != undefined && val.timesheet_entry_value != "deleted" && val.timesheet_entry_value != null){
              if((val.timesheet_entry_value > 0 || row.project_number == "00-006G") && val.timesheet_entry_is_adjustment != '1'){
                total += parseFloat(val.timesheet_entry_value);
              }
            }
          }

          return total;
        }
      },
      dayValue() {
        return (day) => {
          this.updateCounter;
          return day != undefined && day.timesheet_entry_value != "deleted" && day.timesheet_entry_value != null ? parseFloat(day.timesheet_entry_value) : '';
        }
      },
      grandTotal() {
        let total = 0;
        for (const day of this.days) {
          total += this.dayTotal(day);
        }
        return total;
      },
      days() {
        this.updateCounter;
        let days = [];
        let current = this.startDate.clone();
        while(current.diff(this.endDate, "d") <= 0) {
          days.push({
            date: current.format("YYYY-MM-DD"),
            dayShort: L("WEEK_SHORT_"+current.day()),
            dateOfMonth: current.date()
          })
          current = current.add(1, "day")
        }
        return days;
      },
      rowTotal() {
        return (row) => {
          this.updateCounter;
          let total = 0;
          for (const date in row.days) {
            let val = row.days[date]
            if(val != undefined && val.timesheet_entry_value != "deleted" && val.timesheet_entry_value != null){
              if((val.timesheet_entry_value > 0 || row.project_number == "00-006G") && val.timesheet_entry_is_adjustment != '1'){
                total += parseFloat(val.timesheet_entry_value);
              }
            }
          }
          return total;
        }
      },
    },
    methods: {
      projectRenderMethod(state) {
        if (!state.id) {
          return "Chargement des résultats...";
        }
        return $(`<span>${state.text}<span><br><small><b>Société:&nbsp;</b><span>${state.customer_name}</span></small>`);
      },
      rowUpdated(row, data) {
        this.$emit("rowUpdated", row, data, this.rowType)
      },
      projectSelected(row, selected) {
        this.$emit("rowUpdated", row, {
          project_id: selected?.id ?? "removed",
          project_name: selected?.project_name,
          project_number: selected?.project_number,
        }, this.rowType)
      },
      phaseSelected(row, selected) {
        this.$emit("rowUpdated", row, {
          project_phase_id: selected?.id ?? "removed",
          project_phase_number: selected?.project_phase_number,
          project_phase_description: selected?.project_phase_description,
        }, this.rowType)
      },
      activitySelected(row, selected) {
        this.$emit("rowUpdated", row, {
          activity_id: selected?.id ?? "removed",
          activity_number: selected?.activity_number,
          activity_name: selected?.activity_name,
        }, this.rowType)
      },
      deleteRowAsk(row) {
        let that = this;

        bootbox.dialog({
          title: "Supprimer une ligne",
          message: `Voulez-vous vraiment supprimer cette ligne?`,
          buttons: {
            confirm: {
              label: "Supprimer",
              className: "red",
              callback: async function() {
                return await that.deleteRow(row);
              }
            },
            cancel: {
              label: "Annuler",
              className: "secondary",
              callback: function() {},
            }
          }
        })

      },
      deleteRow(row) {
        this.$emit("rowDeleted", row)
      }
    },
  }
</script>